exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.range-picker .form-control {\n    /* background: transparent;\n    cursor: pointer;\n    border: 0;\n    font-size: 22.5px;\n    color: white;\n    height: 100%;\n    padding: 0; */\n}\n", ""]);

// exports
